// extracted by mini-css-extract-plugin
module.exports = {"header":"Name-module--header--vCCRf","name":"Name-module--name--2aZnV","tagline":"Name-module--tagline--2-_o5"};